import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import EmptyAnal from "./EmptyAnal";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import moment from "moment";

const antIcon = (
  <LoadingOutlined style={{ fontSize: 22, color: "white" }} spin />
);

const AnalData = ({ memo, updated, isIndex }) => {
  const [load, setLoad] = useState(false);
  const [locData, setLocData] = useState([]);
  const [dtmData, setDtmData] = useState([]);
  const [orgData, setOrgData] = useState([]);
  const [perData, setPerData] = useState([]);
  const [actData, setActData] = useState([]);
  const [isNoData, setIsNoData] = useState(false);
  const handleClick = useCallback(() => {
    setLoad(true);
    const content = memo;
    axios
      .get("https://api.aiforthai.in.th/tner", {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Apikey: "bXagwMODVlCkp1fxJm7jyZjwy22D81G5",
        },
        params: {
          text: content.slice(0, 600).replace(/%/g, "Percent"),
        },
      })
      .then((res) => {
        const data = res.data;
        let loc = [],
          dtm = [],
          org = [],
          per = [],
          act = [];
        let lC = -1,
          dC = -1,
          oC = -1,
          pC = -1,
          aC = -1;
        console.log(data);
        if (data.words) {
          for (let i = 0; i < data.words.length; i++) {
            if (data.POS[i] === "VV") {
              if (
                data.POS[i - 1] !== "VV" &&
                (data.POS[i + 1] === "VV" || data.POS[i + 1] === "NN")
              ) {
                aC++;
                act.push([data.words[i]]);
              } else if (data.POS[i - 1] === "VV") {
                act[aC].push(data.words[i]);
              }
            }

            if (data.POS[i] === "NN" && data.words[i] !== "วัน") {
              if (data.POS[i - 1] === "VV") {
                act[aC].push(data.words[i]);
              }
            }

            if (
              data.tags[i] === "B-LOC" ||
              (data.tags[i] === "I-LOC" && data.tags[i - 1] !== "B-LOC")
            ) {
              loc.push([data.words[i]]);
              lC++;
            } else if (data.tags[i] === "I-LOC") {
              loc[lC].push(data.words[i]);
            }

            if (data.tags[i] === "B-DTM") {
              dtm.push([data.words[i]]);
              dC++;
            } else if (data.tags[i] === "I-DTM") {
              dtm[dC].push(data.words[i]);
            }

            if (
              data.tags[i] === "B-ORG" ||
              (data.tags[i] === "I-ORG" && data.tags[i - 1] !== "B-ORG")
            ) {
              org.push([data.words[i]]);
              oC++;
            } else if (data.tags[i] === "I-ORG") {
              org[oC].push(data.words[i]);
            }

            if (
              data.tags[i] === "B-PER" ||
              (data.tags[i] === "I-PER" &&
                data.tags[i - 1] !== "B-PER" &&
                data.tags[i - 1] !== " ")
            ) {
              per.push([data.words[i]]);
              pC++;
            } else if (data.tags[i] === "I-PER") {
              per[pC].push(data.words[i]);
            }
          }
          console.log(dtm);
        }

        const loadTime = isIndex ? 500 : 0;
        const allRes =
          loc.length + dtm.length + org.length + per.length + act.length;
        if (allRes === 0) {
          setIsNoData(true);
        }
        setTimeout(() => {
          setLocData(loc);
          setDtmData(dtm);
          setOrgData(org);
          setPerData(per);
          setActData(act);
          if (isIndex) {
            setLoad(false);
          }
        }, loadTime);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [isIndex, memo, setIsNoData]);
  useEffect(() => {
    if (!isIndex) {
      handleClick();
    }
  }, [handleClick, isIndex]);
  return (
    <div className="bg-gray-100 w-full p-3 rounded-md">
      <p className="m-0 p-0 text-blue-400 font-bold">SUMMARY (4W)</p>
      <div className="border-2 border-blue-400 border-dotted w-full py-4 rounded-md my-3">
        {locData.length > 0 ||
        dtmData.length > 0 ||
        orgData.length > 0 ||
        actData.length > 0 ||
        perData.length > 0 ? (
          <div className="px-4">
            {orgData.length > 0 || perData.length > 0 ? (
              <div className="my-3">
                <p className="m-0 ml-2 p-0 text-blue-400 font-bold">WHO</p>
                <ul>
                  {[...new Set(orgData.map((e) => e.join(" ")))].map((e, i) => {
                    return (
                      <li key={i} className="m-0 p-0 text-blue-400 mt-3">
                        {e}
                      </li>
                    );
                  })}
                  {[...new Set(perData.map((e) => e.join(" ")))].map((e, i) => {
                    return (
                      <li key={i} className="m-0 p-0 text-blue-400 mt-3">
                        {e}
                      </li>
                    );
                  })}
                </ul>
              </div>
            ) : null}
            {actData.length > 0 ? (
              <div className="my-3">
                <p className="m-0 ml-2 p-0 text-blue-400 font-bold">WHAT</p>
                <ul>
                  {[...new Set(actData.map((e) => e.join("")))]
                    .filter((e) => e !== "มีจำนวน" && e !== "มีอัตรา")
                    .map((e, i) => {
                      return (
                        <li key={i} className="m-0 p-0 text-blue-400 mt-3">
                          {e}
                        </li>
                      );
                    })}
                </ul>
              </div>
            ) : null}
            {dtmData.length > 0 ? (
              <div className="my-3">
                <p className="m-0 ml-2 p-0 text-blue-400 font-bold">WHEN</p>
                <ul>
                  {[...new Set(dtmData.map((e) => e.join(" ")))]
                    .filter((eF) => eF !== "เดียว")
                    .map((e, i) => {
                      return (
                        <li key={i} className="m-0 p-0 text-blue-400 mt-3">
                          {e === "วัน นี้"
                            ? `${moment(updated).format("Do MMM")}`
                            : e === "พรุ่ง นี้"
                            ? `${moment(updated)
                                .add(1, "days")
                                .format("Do MMM")}`
                            : e}
                        </li>
                      );
                    })}
                </ul>
              </div>
            ) : null}
            {locData.length > 0 ? (
              <div className="my-3">
                <p className="m-0 ml-2 p-0 text-blue-400 font-bold">WHERE</p>
                <ul>
                  {[...new Set(locData.map((e) => e.join(" ")))].map((e, i) => {
                    return (
                      <li key={i} className="m-0 p-0 text-blue-400 mt-3">
                        {e}
                      </li>
                    );
                  })}
                </ul>
              </div>
            ) : null}
          </div>
        ) : !isNoData ? (
          <EmptyAnal isIndex={isIndex} text="PRESS ANALYZE TO START" />
        ) : (
          <div className="h-full w-full flex justify-center items-center">
            <p className="m-0 p-0 text-blue-400 font-bold">
              NO DATA TO BE SUMMARIZE
            </p>
          </div>
        )}
      </div>
      <div
        className={`${
          isIndex
            ? "bg-blue-400 text-white font-bold text-center p-3 rounded-md cursor-pointer hover:bg-blue-500 shadow-sm m-0 border-b-4 border-blue-500 flex justify-center items-center"
            : "hidden"
        }`}
        onClick={() => {
          if (!load) {
            handleClick();
          }
        }}
      >
        {load ? <Spin indicator={antIcon} /> : <span>ANALYZE</span>}
      </div>
    </div>
  );
};

export default AnalData;
